export default "__VITE_ASSET__MFalfkAP__"